import React, { useEffect, useState } from "react";
import StyledCheckbox from "../../Shared/StyledCheckbox";
import SelectAllFiltersButton from "../SelectAllFiltersButton";

export default ({
  _,
  updateDigitalFilters,
  DocumentTypes,
  searchParameters,
}) => {
  const [isAllFiltersSelected, setAllFilters] = useState(false);

  const toggleAllFilters = () => {
    const currentState = isAllFiltersSelected;
    setAllFilters(!currentState);
    updateDigitalFilters({
      filterType: "document-type",
      setAllFilters: true,
      isPartOfSearch: !currentState,
    });
  };
  const { documentTypeFilters } = searchParameters;
  return (
    <div className="document-type-filters">
      <h6>{_.DocumentTypes}</h6>
      <SelectAllFiltersButton
        _={_}
        toggleAllFilters={toggleAllFilters}
        isAllFiltersSelected={isAllFiltersSelected}
      />
      <div className="filters-list">
        {DocumentTypes.map((filter, index) => {
          const isChecked = documentTypeFilters.find((f) => f === filter.id);
          return (
            <div
              key={`document-type-filter-${index}`}
              className="checkbox-text-flex"
            >
              <StyledCheckbox
                key={`${filter.name}-${index}`}
                checked={isChecked}
                onChange={() =>
                  updateDigitalFilters({
                    filterType: "document-type",
                    isPartOfSearch: !isChecked,
                    id: filter.id,
                  })
                }
              />
              {filter.name}
              {/* <span className="filter-document-count orange-text">
              {filter.documentCount !== 0 ? `(${filter.documentCount})` : ""}
            </span> */}
            </div>
          );
        })}
      </div>
    </div>
  );
};
